<template>

<a v-if="outerPath" :href="outerPath" target="_blank" class="sidenav-item-container" v-bind="$attrs">
    <div class="sidenav-item-icon">
        <slot name="icon"/>
    </div>
    <div class="sidenav-item-text">{{ navText }}</div>
</a>
<router-link v-else-if="!outerPath && componentName" :to="toObject" class="sidenav-item-container" v-bind="$attrs">
    <div class="sidenav-item-icon">
        <slot name="icon"/>
    </div>
    <div class="sidenav-item-text" :class="isDentium ? 'dentium' : ''">
        {{ navText }}
        <img v-if="isDentium" src="@/assets/img/sidenav/badge_Dentium.svg"/>
    </div>
</router-link>
<div v-else-if="!componentName" class="sidenav-item-container" v-bind="$attrs">
    <div class="sidenav-item-icon">
        <slot name="icon"/>
    </div>
    <div class="sidenav-item-text">
        {{ navText }}
    </div>
</div>
</template>
<script>
export default {
    name: 'sidenav-item',
    props: {
        componentName: {
            type: String,
            required: false
        },
        navText: {
            type: String,
            required: true
        },
        outerPath: {
            type: String,
            required: false
        },
        isDentium: {
            type: Boolean,
            required: false
        },
        isReady: {
            type: Boolean,
            required: false
        },
        props: {
            type: Object,
            required: false,
        },
    },
    computed: {
        toObject() {
            const obj = {};
            obj.name = this.componentName;
            if(this.props) {
                if(this.props.query) obj.query = this.props.query;
                if(this.props.params) obj.params = this.props.params;
            }
            return obj;
        },
    }
};
</script>
